import { graphql } from "@opensea/graphql"

export const constructCollectionOffer_collectionFragment = graphql(`
  fragment constructCollectionOffer_collection on Collection {
    slug
    chain {
      identifier
      offerCurrency {
        address
      }
    }
    address
  }
`)
